import React from "react";

import {
  usePrivacyContext,
} from "../context/PrivacyContext";



export function PrivacyPreferencesButton(){



  const {

    openPreferences,

    translations,

  } =
    usePrivacyContext();






  return (



    <button


      className="privacy-preferences-button"


      onClick={openPreferences}


    >



      {translations.manageCookies}



    </button>



  );

}